$(document).ready(function () {
	$('.article-body').each(function () {
		var $section = $(this);
		var $toggle = $section.find('.article-body__sidebar-toggle');

		function toggleSidebar(open) {
			$section.toggleClass('is-sidebar-open', open);
			$toggle.attr('aria-expanded', open ? 'true' : 'false');
			$('body').css('overflow', open ? 'hidden' : '');
		}

		$toggle.on('click', function () {
			toggleSidebar(true);
		});

		$section.on('click', '[data-article-sidebar-close]', function () {
			toggleSidebar(false);
		});

		$(document).on('keydown', function (e) {
			if (e.key === 'Escape' && $section.hasClass('is-sidebar-open')) {
				toggleSidebar(false);
			}
		});

		// the panel only exists below 1024px, so close it when the viewport grows past that
		$(window).on('resize', function () {
			if (window.innerWidth > 1023 && $section.hasClass('is-sidebar-open')) {
				toggleSidebar(false);
			}
		});
	});
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/article-body.js